// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { SplGrpAuthGuard } from './splGrp.guard';
import { LayoutComponent } from './layout/layout.component';
import { PlanJourneyComponent } from './home/plan-journey/plan-journey.component';
import { LoginAuthGuard } from './loginAuth.guard';
import { ThingsToDoComponent } from './things-to-do/things-to-do.component';
import { HowToReachComponent } from './how-to-reach/how-to-reach.component';
import { TenantGuard } from './tenant.guard';
import { PayComponent } from './pay/pay.component';
import { ReceiptComponent } from './pay/receipt/receipt.component';
import { OfflineGuard } from './guards/offline.guard';
import { MenuAuthGuard } from './guards/menu-auth.guard';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';

const routes: Routes = [
  { path: 'privacy-policy', component: PrivacyPolicyComponent, title: 'Privacy Policy' },
  { path: 'terms-of-service', component: TermsOfServiceComponent, title: 'Terms of Service' },
  {
    path: '',
    loadChildren: () => import('./main/main.module').then(m => m.MainModule)
  },
  {
    path: ':tenantKey',
    component: LayoutComponent,
    canActivateChild: [TenantGuard],
    children: [
      {
        path: "",
        component: HomeComponent,
        title: "Kinvyt"
      },
      {
        path: "home",
        component: HomeComponent,
        title: "Kinvyt"
      },
      // {
      //   path: 'pay',
      //   component: PayComponent,
      //   canActivate: [OfflineGuard],
      //   title: 'Pay | Kinvyt'
      // },
      // {
      //   path: 'pay/receipt',
      //   component: ReceiptComponent,
      //   title: 'Payment Acknowledgement | Kinvyt'
      // },
      {
        path: 'planJourney',
        component: PlanJourneyComponent,
        canActivate: [MenuAuthGuard],
        data: { menuKey: 'planJourney' },
        title: 'Plan My Journey | Kinvyt'
      },
      {
        path: 'thingsToDo',
        component: ThingsToDoComponent,
        canActivate: [MenuAuthGuard],
        data: { menuKey: 'thingsToDo' },
        title: 'Places to Visit | Kinvyt'
      },
      {
        path: 'howToReach',
        component: HowToReachComponent,
        canActivate: [MenuAuthGuard],
        data: { menuKey: 'howToReach' },
        title: 'How to Reach | Kinvyt'
      },
      {
        path: 'guests',
        loadChildren: () => import('./guests/guests.module').then(m => m.GuestsModule)
      },
      { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
      { path: 'event', loadChildren: () => import('./events/events.module').then(m => m.EventsModule) },
      { path: 'wedding', loadChildren: () => import('./events/events.module').then(m => m.EventsModule) },
      { path: 'gallery', loadChildren: () => import('./gallery/gallery.module').then(m => m.GalleryModule) },
      {
        path: 'login',
        component: LoginComponent,
        title: 'Login'
      },
      {
        path: 'splGrp',
        loadChildren: () => import('./spl-grp/spl-grp.module').then(m => m.SplGrpModule),
        canActivate: [SplGrpAuthGuard],
        canActivateChild: [SplGrpAuthGuard]
      },
      {
        path: 'developer',
        loadChildren: () => import('./developer/developer.module').then(m => m.DeveloperModule)
      },

      //To catch all the undefined routes
      {
        path: "**",
        redirectTo: '',
        pathMatch: 'full',
        title: "Kinvyt"
      },
    ]
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
